import React from "react";
import { Input, Row, Typography, Select, Form, Divider, Col } from "antd";
import { labelConfig, staticConfig } from "../../systemAdmin.config";
import { BOM } from "../../../../services/definedMethod";

const { Title } = Typography;

const ConfigForm = (props) => {
  const {
    onFinish,
    form,
    formData,
    officeData,
    glAccountData,
    branchConfigList,
    setSelectedbranchConfigValue
  } = props;

  return (
    <Form layout="vertical" onFinish={onFinish} form={form}>
      <Row>
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {labelConfig.newVaultConfiguration}
          </Title>
        </Divider>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.branch}
            name={"operationId"}
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.branch),
              },
            ]}
          >
            <Select
            
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.branch,
                "select"
              )}
              options={branchConfigList}
              onChange={(val) => setSelectedbranchConfigValue(val)} // val is now an object { label, value }
              allowClear
              showSearch
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.vaultGL}
            name={"vaultGl"}
            // rules={[
            //   {
            //     required: true,
            //     message: "Required Field",
            //   },
            // ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.vaultGL,
                "select"
              )}
              showSearch
              options={glAccountData}
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.tillGL}
            name={"tillGl"}
            // rules={[
            //   {
            //     required: true,
            //     message: "Required Field",
            //   },
            // ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.vaultGL,
                "select"
              )}
              showSearch
              options={glAccountData}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default ConfigForm;
